import React from 'react';
import './Banner.css';

const Banner = ({ image }) => {
  return (
    <div className="banner">
      <h2 className="banner-text">
        "Redefining <span className="highlight">Value</span> in a<br />Skill-Based World"
      </h2>
      {image && <img src={image} alt="Banner" className="banner-image" />}
    </div>
  );
};

export default Banner;
